import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { LoginSchema, Mobileschema } from "../../components/validationSchema";
import { InputBox, Password } from "../../components/CustomWidgets/InputBox";
import { Link, useNavigate } from "react-router-dom";
import Button from "../../components/CustomWidgets/Button";
import { routes } from "../../Routes";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import {
  setUserDetail,
  setAccessToken,
  setRetailerInfo,
  setAuthenticated,
} from "../../components/Actions/AuthAction";
import ShimmerLoader from "../../loading";
import LoginPopup from "../../Popups/LoginPopup";
import {
  GetLoginRetailers,
  LoginData,
  loginUser,
  loginUserSuccess,
  sendLoginOTP,
  setMasterStore,
  setSelectedStore,
} from "../../Redux/Action/loginAction";
import { useTranslation } from "react-i18next";
import LoaderComponent from "../../Loader";
import LoadingSpinner from "../../components/Loading";
import { toast } from "react-toastify";
import { Input } from "antd";
import FlagIcon from "../../assets/egypt.svg";
import OTPModal from "../../modals/verifyOTP";
import i18n from "../../i18n";
import SelectLoginRetailers from "../../modals/SelectLoginRetailers";
import { getUserOnboarding } from "../../API  Functions/DashboardFunctions";
import { setGinneLogin } from "../../Redux/Action/GeneLoginAction";

const LoginForm = ({ isPriceChecker, setCompanyIDForPriceChecker }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state?.login);

  const dispatch = useDispatch();

  const [Loading, setLoading] = useState(false);
  const [error, seterror] = useState(0);
  const [popup, setpopup] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [showOTPModal, setShowOTPModal] = useState(false);
  const [selectRetailersModal, setSelectRetailersModal] = useState(false);
  const [ginneRetailers, setGinneRetailers] = useState([]);
  const [mobile, setMobile] = useState("");
  const location = useLocation();

  const isGinneLogin = location.pathname === "/teamlogin";
  const [loginMode, setLoginMode] = useState("email"); // "email" | "mobile"
  const [otp, setOtp] = useState("");
  useEffect(() => {
    if (isGinneLogin) {
      setLoginMode("mobile");
    }
  }, [isGinneLogin]);

  const formik = useFormik({
    initialValues: {
      phoneNumber: "",
    },
    validationSchema: Mobileschema,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        const data = await dispatch(
          sendLoginOTP(values.phoneNumber?.replace(/^0+/, ""), isGinneLogin),
        );
        // Check if the response contains an error message
        if (data?.result?.status == 200) {
          setOtp(data?.result?.otp);
          setMobile(values.phoneNumber?.replace(/^0+/, ""));
          setShowOTPModal(true);
        } else {
          setMobile("");
          toast.error(t(data?.result.status));
        }
      } catch (error) {
        console.error("Error occurred during login:", error);
      } finally {
        setLoading(false);
      }
    },
  });

  const emailFormik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: LoginSchema,
    validateOnBlur: true,
    validateOnChange: false,
    onSubmit: async (values) => {
      try {
        const errors = await emailFormik.validateForm();
        if (Object.keys(errors).length > 0) {
          emailFormik.setTouched({
            email: true,
            password: true,
          });
          return; // ❌ STOP HERE — No API call
        }
        setLoading(true);
        const emailOrPhone =
          values?.email.charAt(0) == 0
            ? values?.email?.substring(1, 11)
            : values?.email;

        const userData = await dispatch(
          loginUser(emailOrPhone, values.password),
        );
        const data = userData?.data?.result;
        if (data?.status_code === 200) {
          if (isPriceChecker) {
            localStorage.setItem("priceCheckerLogin", JSON.stringify(data));
            setCompanyIDForPriceChecker(data?.company_id);
          } else {
            dispatch(setGinneLogin(false));
            if (data?.is_master_store) {
              const masterStore = {
                store_id: data?.company_id,
                store_name: data?.company_name,
                store_name_ar: data?.company_name_ar,
                store_email: data?.email,
                user_id:data?.user_id,
                is_master: true,
              };

              const displayStore = {
                ...masterStore,
                store_name:
                  i18n.language === "ar"
                    ? masterStore.store_name_ar
                    : masterStore.store_name_en,
              };

              dispatch(setMasterStore(masterStore));
              dispatch(setSelectedStore(masterStore)); // default selected store = master
              localStorage.setItem(
                "selectedSubstore",
                JSON.stringify(masterStore),
              );
            }

            if (data?.is_retailer === false) {
              if (data?.is_pos_user) {
                toast.error(t("You can not login with POS user credentials"));
              } else {
                dispatch(loginUserSuccess(userData?.data));
                navigate(routes.orders);
              }
            } else {
              setpopup(true);
              let isOnboarded = await CheckUserOnboarding(data?.company_id);
              setTimeout(() => {
                {
                  dispatch(loginUserSuccess(userData?.data));
                  if (data?.remaining_days <= 0) {
                    navigate("/settings/subscription", {
                      state: { fromRegister: true },
                    });
                  } else if (isOnboarded) {
                    navigate("/dashboard");
                  } else {
                    navigate("/onboarding");
                  }
                }
              }, 1000);
            }
            setLoading(false);
          }
        } else {
          toast.error(t(data?.status || "Invalid credentials"));
        }
      } catch (err) {
        toast.error("Login failed");
      } finally {
        setLoading(false);
      }
    },
  });

  const GetLoginData = async (email, isInternalLogin) => {
    setSelectRetailersModal(false);
    let payload = {
      user_name: email,
    };
    try {
      const data = await dispatch(LoginData(payload));

      if (data?.result?.status_code === 200) {
        setShowOTPModal(false);

        if (isPriceChecker) {
          localStorage.setItem("priceCheckerLogin", JSON.stringify(data?.result));
          setCompanyIDForPriceChecker(data?.result?.company_id);
        } else {
          if (isInternalLogin) {
            dispatch(setGinneLogin(true));
          } else {
            dispatch(setGinneLogin(false));
          }

          if (data?.result?.is_master_store) {
            const masterStore = {
              store_id: data.result.company_id,
              store_name: data.result.company_name,
              store_name_ar: data.result.company_name_ar,
              store_email: data.result.email,
              user_id:data?.user_id,
              is_master: true,
            };
            console.log("masterStore", masterStore);

            const displayStore = {
              ...masterStore,
              store_name:
                i18n.language === "ar"
                  ? masterStore.store_name_ar
                  : masterStore.store_name_en,
            };

            dispatch(setMasterStore(masterStore));
            dispatch(setSelectedStore(masterStore)); // default selected store = master
            localStorage.setItem(
              "selectedSubstore",
              JSON.stringify(masterStore),
            );
          }

          if (data?.result?.is_retailer === false) {
            if (data?.result?.is_pos_user) {
              toast.error(t("You can not login with POS user credentials"));
            } else {
              dispatch(loginUserSuccess(data));
              navigate(routes.orders);
            }
          } else {
            setpopup(true);
            let isOnboarded = await CheckUserOnboarding(
              data?.result?.company_id,
            );
            setTimeout(() => {
              {
                dispatch(loginUserSuccess(data));
                if (data?.result?.remaining_days <= 0) {
                  navigate("/settings/subscription", {
                    state: { fromRegister: true },
                  });
                } else if (isOnboarded) {
                  navigate("/dashboard");
                } else {
                  navigate("/onboarding");
                }
              }
            }, 1000);
          }
        }
      } else {
        toast.error(t(data?.result?.status));
        // setShowIncorrectOTPMessage(true);
      }
    } catch (error) {
      console.error("Error during OTP verification:", error);
    }
  };

  const CheckUserOnboarding = async (company_id) => {
    try {
      const res1 = await getUserOnboarding(company_id);

      if (res1?.result[0].status_code == 200) {
        let keys = res1?.result[0];

        if (
          keys?.update_inventory &&
          keys?.cashier_setup &&
          keys?.weighing_scale &&
          keys?.add_user &&
          keys?.delivery_company
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
    } finally {
    }
  };

  const GetRetilers = async (phone) => {
    setShowOTPModal(false);
    let payload = {
      phone: mobile,
      lang: i18n.language == "ar" ? "ar_001" : "en_US",
    };
    try {
      const data = await dispatch(GetLoginRetailers(payload));
      if (data?.result?.status_code === 200) {
        setSelectRetailersModal(true);
        setGinneRetailers(data?.result?.response);
      } else {
        toast.error(t(data?.result?.status));
        // setShowIncorrectOTPMessage(true);
      }
    } catch (error) {
      console.error("Error during OTP verification:", error);
    }
  };

  // console.log('user====>',user);
  const getMaxLength = (mobile) => {
    return mobile?.startsWith("0") ? 11 : 10;
  };
  return (
    <div className="mx-auto mt-4 w-full sm:mt-6">
      {Loading && <LoadingSpinner />}

      {/* ================= EMAIL + PASSWORD LOGIN ================= */}
      {loginMode === "email" && !isGinneLogin && (
        <form onSubmit={emailFormik.handleSubmit} className="space-y-4">
          <div>
            <InputBox
              label={t("Email / Mobile no.")}
              name="email"
              placeholder={t("Enter Mobile number or email address")}
              maxLength={40}
              onChange={emailFormik.handleChange}
              onBlur={emailFormik.handleBlur}
              value={emailFormik.values.email}
              error={emailFormik.errors.email}
              touched={emailFormik.touched.email}
            />
            {emailFormik.errors.email && (
              <div className="text-xs text-red ">
                {t(emailFormik.errors.email)}
              </div>
            )}
          </div>
          <div>
            <Password
              show={0}
              label={t("Password")}
              type="password"
              name="password"
              placeholder={t("Enter Password")}
              onChange={emailFormik.handleChange}
              onBlur={emailFormik.handleBlur}
              value={emailFormik.values.password}
              error={emailFormik.errors.password}
              touched={emailFormik.touched.password}
              // secureTextEntry
            />
            {emailFormik.errors.password && (
              <div className="text-xs text-red mt-1">
                {t(emailFormik.errors.password)}
              </div>
            )}
          </div>

          <div className="mt-2 flex justify-end">
            <Link
              to={routes.forgotPassword}
              className="mt-0 cursor-pointer text-sm font-normal text-black"
            >
              {t("Forgot password ?")}
            </Link>
          </div>
          <button
            type="submit"
            className="mt-4 my-4 flex w-full items-center justify-center rounded-lg bg-primaryBlue p-3 text-sm font-semibold text-white sm:text-base"
            disabled={Loading}
          >
            {t("Login")}
            {Loading && (
              <div className="ms-4">
                <LoaderComponent />
              </div>
            )}
          </button>

          <div className="mt-4 text-center">
            <span className="text-gray-400 text-sm">— {t("or")} —</span>

            <button
              type="button"
              onClick={() => setLoginMode("mobile")}
              className="mt-4 my-4 flex w-full items-center justify-center rounded-lg border-2 border-gray bg-white p-3 text-sm font-medium text-black sm:text-base"
            >
              {t("Login with code")}
            </button>
          </div>
        </form>
      )}

      {/* ================= MOBILE OTP LOGIN (YOUR EXISTING UI) ================= */}
      {loginMode === "mobile" && (
        <form onSubmit={formik.handleSubmit}>
          <div style={{ direction: "ltr" }} className="mt-5 flex flex-col">
            <label
              className={`py-2 text-sm text-gray-600 font-medium ${
                i18n.language == "ar" ? "self-end" : ""
              }`}
            >
              {t("Mobile Number")}
            </label>

            <div className="mt-0 flex w-full flex-row items-center">
              <div className="flex h-10 w-14 shrink-0 items-center justify-center rounded-md border p-2 text-md text-body outline-none focus:outline-none sm:w-16 sm:p-3">
                <img src={FlagIcon} height={50} width={50} alt="img" />
              </div>

              <Input
                type="tel"
                placeholder={t("01-xxxxxxxx")}
                value={formik.values.phoneNumber}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                name="phoneNumber"
                maxLength={getMaxLength(formik?.values.phoneNumber)}
                className={`ms-2 h-10 w-full text-sm text-body outline-none focus:outline-none ltr:pl-5 rtl:pr-5 rounded-md border p-3 sm:text-base ${
                  (formik.touched.phoneNumber && formik.errors.phoneNumber) ||
                  showNotification
                    ? "border-red"
                    : ""
                }`}
              />
            </div>

            {showNotification && (
              <div className="ml-1 mt-1 flex justify-start text-sm text-red sm:ml-16">
                {t("user_exist")}
              </div>
            )}
          </div>

          {formik?.errors?.phoneNumber && (
            <div className="text-xs text-red">
              {t(formik?.errors?.phoneNumber)}
            </div>
          )}

          <button
            type="submit"
            className="mt-4 my-4 flex w-full items-center justify-center rounded-lg bg-primaryBlue p-3 text-sm font-semibold text-white sm:text-base"
            disabled={Loading}
          >
            {t("Send Code")}
            {Loading && (
              <div className="ms-4">
                <LoaderComponent />
              </div>
            )}
          </button>

          {!isGinneLogin && (
            <div className="mt-4 text-center">
              <span className="text-gray-400 text-sm">— {t("or")} —</span>

              <button
                type="button"
                onClick={() => setLoginMode("email")}
                className="mt-4 my-4 flex w-full items-center justify-center rounded-lg border-2 border-gray bg-white p-3 text-sm font-medium text-black sm:text-base"
              >
                {t("Login with email and password")}
              </button>
            </div>
          )}
        </form>
      )}

      {/* ================= EXISTING MODALS ================= */}
      {showOTPModal && (
        <OTPModal
          type={"login"}
          mobile={mobile}
          isOpen={showOTPModal}
          numberChange={() => setShowOTPModal(false)}
          onClose={() => setShowOTPModal(false)}
          isGinneLogin={isGinneLogin}
          otp={otp}
          payload={() => setShowOTPModal(false)}
          GetLoginData={isGinneLogin ? GetRetilers : GetLoginData}
        />
      )}

      {selectRetailersModal && (
        <SelectLoginRetailers
          retailers={ginneRetailers}
          isOpen={selectRetailersModal}
          onClose={() => setSelectRetailersModal(false)}
          LoginWithRetails={GetLoginData}
        />
      )}

      {popup && <LoginPopup onClose={() => setpopup(false)} />}
    </div>
  );
};

export default LoginForm;
